// Phase 3B (Task 3.4) — <CopilotChatInput />.
//
// The bottom message composer of the Copilot chat thread, adapted from the
// Metronic Todo `aside-input.tsx`. Rendered DISABLED ("coming soon") for this
// milestone: the chat round-trip (enabling the input + a `chat` event producer)
// is an explicit out-of-scope follow-up (plan §8). The disabled affordance is
// kept in the tree so the thread reads as a chat surface and the enable later
// is a one-prop change, not a re-layout.

import { Send } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Input } from '@marine/ui/input';
import { Button } from '@marine/ui/button';

interface CopilotChatInputProps {
  className?: string;
}

export function CopilotChatInput({ className }: CopilotChatInputProps) {
  return (
    <div className={cn('relative', className)} data-testid="copilot-chat-input">
      <div className="relative flex flex-col gap-2 rounded-2xl border bg-background p-3 shadow-sm">
        <Input
          type="text"
          value=""
          readOnly
          disabled
          placeholder="Chat with AI Deckhand — coming soon"
          aria-label="Chat with AI Deckhand (coming soon)"
          className="h-auto flex-1 border-0 bg-transparent px-0 text-sm shadow-none placeholder:text-muted-foreground focus-visible:ring-0"
        />
        <div className="flex items-center justify-end">
          <Button
            variant="ghost"
            mode="icon"
            className="rounded-xl opacity-50"
            disabled
            aria-label="Send message (coming soon)"
            type="button"
          >
            <Send className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
